import jsPDF from "jspdf";
import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReportPdfView from "./report_pdf_view/ReportPdfView";
import { CircularProgress } from "@mui/material";
import axios, { AxiosRequestConfig } from "axios";
import FormData from "form-data";
import { preprocessNodeForPdf } from "../utils/helper";

const ReportConvertToPdf: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [uploading, setUploading] = useState(false);

  let uploadToDropboxBtnRef = useRef<HTMLButtonElement>(null);

  const {
    laboratoryDirector,

    //Patient Table
    patientName,
    patientDOB,
    patientSex,
    patientID,
    orderBy,
    reportRecipient,
    contactInfo,
    amendedNotes,

    //Patient Sample Information
    orderDate,
    collectedDate,
    collectedTime,
    patientSampleType,
    reportedDate,
    sampleID,
    institutionSampleID,

    //datepoints
    datePointsTable,
  } = location.state || {};


  async function generatePdf(generateOnly = false): Promise<any> {
    return new Promise(async (resolve, reject) => {
      var pdf = new jsPDF("p", "pt", "a4", true);

      // Assuming the fonts are placed correctly in the fonts directory
      const JoannaRegular = require("./../fonts/JoannaSansNovaRegular.TTF");
      const JoannaBold = require("./../fonts/JoannaSansNovaBold.TTF");
      const JoannaMedium = require("./../fonts/JoannaSansNovaMedium.TTF");
      const JoannaLight = require("./../fonts/JoannaSansNovaLight.TTF");
      const JoannaThin = require("./../fonts/JoannaSansNovaThin.TTF");

      // const JoannaRegular = require("./../fonts/transfonter.org-20250726-183533/JoannaSansNova-Regular.woff2");
      // const JoannaBold = require("./../fonts/transfonter.org-20250726-183533/JoannaSansNova-Bold.woff2");
      // const JoannaMedium = require("./../fonts/transfonter.org-20250726-183533/JoannaSansNova-Medium.woff2");
      // const JoannaLight = require("./../fonts/transfonter.org-20250726-183533/JoannaSansNova-Light.woff2");
      // const JoannaThin = require("./../fonts/transfonter.org-20250726-183533/JoannaSansNova-Thin.woff2");

      // Add the custom fonts with their appropriate weights
      pdf.addFont(JoannaRegular, "JoannaSansNova", "normal"); // Regular weight
      pdf.addFont(JoannaBold, "JoannaSansNova", "bold");     // Bold weight
      pdf.addFont(JoannaMedium, "JoannaSansNova", "medium"); // Medium weight
      pdf.addFont(JoannaLight, "JoannaSansNova", "light");   // Light weight
      pdf.addFont(JoannaThin, "JoannaSansNova", "thin");     // Thin weight

      document.body.style.marginTop = "0px";
      document.body.style.marginBottom = "0px";

      setTimeout(() => {
        var documentBody = document.getElementById("report_pdf_view_container");
        if (documentBody) {


          documentBody.setAttribute("class", "report-preveiw pdf-download");

          const processed = preprocessNodeForPdf(documentBody);

          if (processed) {

            pdf.html(processed as HTMLElement, {
              callback: function (pdf: any) {
                console.log("pdf: ", pdf);

                document.body.style.width = "initial";
                if (documentBody) {
                  documentBody.setAttribute("class", "report-preveiw");
                }
                if (generateOnly === false) {
                  pdf.save("final_report.pdf");

                  resolve(null);
                }
                else {
                  let pdfContent = pdf.output('arraybuffer');
                  const saveContent = (content: any) => {
                    const blob = new Blob([content], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.download = 'final_report.pdf';
                    link.href = url;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  };
                  resolve(pdfContent);
                }
              },
            });
          }
        } else {
          resolve(null);
        }
      }, 250);
    });
  }


  async function uploadToBox() {
    setUploading(true);

    let pdfData = await generatePdf(true);

    console.log("printing pdfData: ");
    console.log(pdfData);

    if (!pdfData) {
      setUploading(false);
      return;
    }

    try {
      const pdfFile = new Blob([pdfData], { type: 'application/pdf' });
      const formData = new FormData();
      formData.append('pdfFile', pdfFile);
      formData.append('isBase64Encoded', false);

      const option: AxiosRequestConfig = {
        url: `${process.env.REACT_APP_NODE_ENV === 'prod' ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV}/uploadToBox`,
        data: formData,
        method: "POST",

        headers: {
          "Content-Type": "multipart/form-data",
        },
        maxBodyLength: Infinity,
      };
      const response = await axios(option);

      console.log("uploadToBox->>To Path: ", response.data);
    } catch (error) {
      console.log("uploadToBox->>error: ", error);
      setUploading(false);
    } finally {
      setUploading(false);
    }
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ReportPdfView
            laboratoryDirector={laboratoryDirector}
            //Patient Table
            patientName={patientName}
            patientDOB={patientDOB}
            patientSex={patientSex}
            patientID={patientID}
            orderBy={orderBy}
            reportRecipient={reportRecipient}
            contactInfo={contactInfo}
            amendedNotes={amendedNotes}
            //Patient Sample Information
            orderDate={orderDate}
            collectedDate={collectedDate}
            collectedTime={collectedTime}
            patientSampleType={patientSampleType}
            reportedDate={reportedDate}
            sampleID={sampleID}
            institutionSampleID={institutionSampleID}
            //datepoints
            datePointsTable={datePointsTable}
            masterCssClassName={"report-preveiw"}
            previewReportRecipientInfoFieldCssClass={"preview-report-recipient-field"}
            previewContactInfoFieldCssClas={"preview-contact-info-field"}
            topCssClass={"top"}
            previewChartContainerCssClass={"preview-chart-container"}
            pdfViewFinalReportSectionCssClass={"pdfview-final-report-section"}
            forLocalPdf={true}
          />
        </div>
        <div style={{ position: "absolute", top: "30px", right: "50px", display: "flex", gap: "20px" }}>
          <div
            onClick={() => {
              generatePdf();
            }}
            id="d"
            style={{
              height: "40px",
              width: "120px",
              borderRadius: "10px",
              backgroundColor: "#633477",
              color: "white",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
              cursor: "pointer",
              fontWeight: "700",
            }}
          >
            DownLoad
          </div>
          <button
            disabled={uploading}
            ref={uploadToDropboxBtnRef}
            onClick={async () => {
              await uploadToBox();
            }}
            id="btn_upload_to_dropbox"
            style={{
              height: "40px",
              width: "120px",
              borderRadius: "10px",
              backgroundColor: "#633477",
              color: "white",
              // display: "flex",
              // justifyContent: "center",
              // flexDirection: "column",
              textAlign: "center",
              cursor: "pointer",
              fontWeight: "700",
            }}
          >
            {uploading ? <CircularProgress /> : 'Upload'}
          </button>
          <div
            onClick={() => {
              navigate(-1);
            }}
            id="d"
            style={{
              height: "40px",
              width: "120px",
              borderRadius: "10px",
              backgroundColor: "#013a5d",
              color: "white",
              display: "flex",
              fontWeight: "700",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            Back
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportConvertToPdf;
